import script from "./RuleGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./RuleGroup.vue?vue&type=script&setup=true&lang=js"

import "./RuleGroup.vue?vue&type=style&index=0&id=40ca5094&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40ca5094"]])

export default __exports__